import { ROUTES } from '@/config/routes.config';

type RedirectRule = {
  from: string;
  to: string;
};

/**
 * Redirects legacy -> canónico (Shopify-like).
 * Mantener 1–2 releases y luego evaluar eliminación.
 */
export const LEGACY_REDIRECTS_CORE: RedirectRule[] = [
  { from: '/dashboard', to: ROUTES.HOME },
  { from: '/sales/orders', to: ROUTES.ORDERS },
  { from: '/sales/statistics', to: ROUTES.ANALYTICS },
];

export const LEGACY_REDIRECTS_RESTAURANT: RedirectRule[] = [
  { from: '/pos', to: ROUTES.APPS_RESTAURANT_POS },
  { from: '/kds', to: ROUTES.APPS_RESTAURANT_KDS },
  { from: '/admin/menu', to: ROUTES.APPS_RESTAURANT_MENU },
  { from: '/tables', to: ROUTES.APPS_RESTAURANT_TABLES },
  // rutas en español (compat)
  { from: '/apps/restaurante', to: ROUTES.APPS_RESTAURANT },
  { from: '/apps/restaurante/pos', to: ROUTES.APPS_RESTAURANT_POS },
  { from: '/apps/restaurante/kds', to: ROUTES.APPS_RESTAURANT_KDS },
  { from: '/apps/restaurante/menu', to: ROUTES.APPS_RESTAURANT_MENU },
  { from: '/apps/restaurante/tables', to: ROUTES.APPS_RESTAURANT_TABLES },
];

export const LEGACY_REDIRECTS_SETTINGS: RedirectRule[] = [
  { from: '/users', to: ROUTES.SETTINGS_USERS },
  { from: '/modules', to: ROUTES.SETTINGS_APPS_AND_SALES_CHANNELS },
  // Avisos salió de Configuración al menú principal (#1137), pero la pantalla había quedado
  // colgando de los DOS lados: entrada en el nav de Ajustes y entrada en el menú, misma página.
  // Ahora vive en un solo lugar y el camino viejo redirige.
  { from: ROUTES.SETTINGS_NOTIFICATIONS_WHATSAPP, to: ROUTES.AVISOS },
];

export const LEGACY_REDIRECTS_ECOMMERCE: RedirectRule[] = [
  { from: '/ecommerce', to: ROUTES.ONLINE_STORE },
  { from: '/ecommerce/customize', to: ROUTES.ONLINE_STORE_THEMES },
  { from: '/ecommerce/pages', to: ROUTES.ONLINE_STORE_PAGES },
  { from: '/ecommerce/menus', to: ROUTES.ONLINE_STORE_NAVIGATION },
  { from: '/ecommerce/branding', to: ROUTES.SETTINGS_BRAND },
  { from: '/ecommerce/config/domains', to: ROUTES.SETTINGS_DOMAINS },
  { from: '/ecommerce/config/notifications', to: ROUTES.SETTINGS_NOTIFICATIONS },
  { from: '/ecommerce/config/payment-methods', to: ROUTES.SETTINGS_PAYMENTS },
  { from: '/ecommerce/checkout', to: ROUTES.SETTINGS_CHECKOUT },
  { from: '/ecommerce/logistics/delivery-methods', to: ROUTES.SETTINGS_DELIVERY_METHODS },
  { from: '/ecommerce/logistics/delivery-rules', to: ROUTES.SETTINGS_DELIVERY_RULES },
  { from: '/ecommerce/config/shipping-methods', to: ROUTES.SETTINGS_SHIPPING_METHODS },
  { from: '/ecommerce/orders', to: ROUTES.ORDERS_ONLINE },
  { from: '/ecommerce/abandoned-carts', to: ROUTES.ORDERS_ABANDONED },
  { from: '/ecommerce/analytics', to: ROUTES.ANALYTICS },
];

